import { Plugin } from "..";
import { defaultVibrationCriteriaDataOptions } from "./vibration-criteria-data-options";

export const VibrationCriteriaGraph: Plugin = {
	id: "safe-limit-graph",
	type: "event",
	header: {
		visible: true,
		edit: true,
		fullscreen: true,
	},
	name: "vibrationCriteriaGraph",
	component: defineAsyncComponent(() => import("./VibrationCriteriaGraphPlugin.vue")),
	config: defineAsyncComponent(() => import("./VibrationCriteriaGraphPluginConfig.vue")),
	dataConfig: defineAsyncComponent(() => import("./VibrationCriteriaGraphDataConfig.vue")),
	defaultDataResolver: () => defaultVibrationCriteriaDataOptions,
	defaultOptionsResolver: () => undefined,
	dimension: {
		minHeight: 4,
		minWidth: 4,
	},

	currentVersion: 1,
	migrations: {},
};
